import { MEMBERS_DEFAULT } from "types/actions/members"

const membersInitialState = []

export default (state = membersInitialState, action) => {
  switch (action.type) {
    case MEMBERS_DEFAULT:
      return action && action.data ? action.data : state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/members.js